module.exports = __webpack_public_path__ + "img/کارت-ویزیت-سلفون-مخملی-طلا-کوب.0bc67558.png";